import React, { useContext, useMemo, useRef } from 'react'
import classNames from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import { getIpadVh } from 'common/ipad'
import qs from 'qs'
import { ImageDetailContext } from '../content'
import Info from './info'
import Annotation from './annotation'
import Comment from './comment'
import { ShareType } from '../../../home/intellectRecommend/recommendCard/inspiration/shareType'
import imageDetailForceGuide, { GUIDE_KEYS } from '../forceGuideConfig'
import styles from './index.module.less'

export enum IMAGE_DETAIL_TAB {
    INFO = 1,
    ANNOTATION = 2,
    COMMENT = 3,
    RECOMMEND = 4
}

export default ({ imgInfoList }) => {
  const {
    currentImage,
    tabValue,
    onTabChange,
    notes,
    onIsAnnotate,
    isAnnotate,
    setNotes,
    onActiveNoteIndex,
    queryParams,
    commentTotal,
    onInitCommentTotal,
    isMove,
    isShowRight,
    onIsShowRight,
  }:any = useContext(ImageDetailContext)
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const transformStyle = useMemo(() => {
    if (tabValue === IMAGE_DETAIL_TAB.RECOMMEND || isShowRight) {
      return {
        marginRight: '-440px'
      }
    }
    return {
      marginRight: '0px'
    }
  }, [tabValue, isShowRight])

  const TAB_OPTION = [
    { label: '款式信息', value: IMAGE_DETAIL_TAB.INFO, auth: true },
    { label: '批注', value: IMAGE_DETAIL_TAB.ANNOTATION, auth: query.shareType !== ShareType.OFFICIAL },
    { label: '评论', value: IMAGE_DETAIL_TAB.COMMENT, num: commentTotal, auth: query.shareType !== ShareType.OFFICIAL },
    { label: '相似推荐', value: IMAGE_DETAIL_TAB.RECOMMEND, auth: currentImage.loginUserInfo?.role !== -1 }
  ]
  const domRef = useRef(null)
  imageDetailForceGuide.useEmit(GUIDE_KEYS.STEP_2, domRef)

  return <div
    className={styles.mnImageDetailInfoView}
    style={{ ...transformStyle, height: getIpadVh() }}
    ref={domRef}
  >
    <HangTab
      value={tabValue}
      onChange={(val) => onTabChange(val)}
      options={TAB_OPTION.filter(i => i.auth)}
      isShowRight={isShowRight}
      hasShowRightBtn={tabValue === IMAGE_DETAIL_TAB.ANNOTATION}
      onIsShowRight={(val) => onIsShowRight(val)}
    />
    {tabValue === IMAGE_DETAIL_TAB.INFO && <Info imgInfoList={imgInfoList} />}
    {tabValue === IMAGE_DETAIL_TAB.ANNOTATION && <Annotation
      notes={notes}
      currentImage={currentImage}
      setNotes={setNotes}
      setIsAnnotate={onIsAnnotate}
      isAnnotate={isAnnotate}
      onActiveNoteIndex={onActiveNoteIndex}
      isMove={isMove}
      loginUserInfo={currentImage.loginUserInfo}
    />}
    {tabValue === IMAGE_DETAIL_TAB.COMMENT && <Comment
      blogId={queryParams}
      loginUserInfo={currentImage.loginUserInfo}
      collectId={queryParams.collectId}
      total={commentTotal}
      onInitCommentTotal={onInitCommentTotal}
    />}
  </div>
}

export const HangTab = ({ value, onChange, onIsShowRight, isShowRight, options, hasShowRightBtn }) => {
  return <>
    {
      hasShowRightBtn && <div className={classNames(styles.infoViewHangTabShowBtn, 'fill-white-bg')} onClick={() => onIsShowRight(!isShowRight)}>
        {isShowRight && <Icon type="m-Vxing_zuo" className={styles.infoViewHangTabShowBtnIcon} />}
        {isShowRight ? '展开' : '收起'}
        {!isShowRight && <Icon type="m-Vxing_you" className={styles.infoViewHangTabShowBtnIcon} />}
      </div>
    }
    <div className={styles.infoViewHangTab}>
      {
        options.map(item => <div
          key={item.value}
          onClick={() => {
            onIsShowRight(false)
            onChange(item.value, item)
          }}
          className={classNames('infoViewHangTabItem', { active: item.value === value })}
        >
          <span>
            {item.label}
            {!!item.num && <span className="infoViewHangTabItemNum">{item.num > 99 ? '99+' : item.num}</span>}
          </span>
        </div>)
    }
    </div>
  </>
}
